import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=587d4d18&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"
import style0 from "./Suppliers.vue?vue&type=style&index=0&id=587d4d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d4d18",
  null
  
)

export default component.exports